import { useGetLayouts } from '@vindr/services/actions/layout.action';
import { useDebounce } from '@vindr/utils/hooks/useDebounce';
import useRoleMemo from '@vindr/utils/hooks/useRoleMemo';
import { Select } from 'antd';
import { FormItemProps } from '../templates/FormProps';
import FormSelect from '../templates/FormSelect';

interface ProcedureGroup extends FormItemProps {
  institutionId?: string;
}

const LayoutList = ({
  name = 'layout_id',
  label = 'Layout List',
  placeholder = 'Select Layout List',
  rules,
  multiple = false,
  required = false,
  onChange,
  disabled,
  institutionId,
  ...props
}: ProcedureGroup) => {
  const [searchTerm, handleSearch] = useDebounce<string>();

  const { data, isInitialLoading, isRefetching } = useGetLayouts({
    limit: 100,
    offset: 0,
    active: true,
    institution_ids: institutionId,
    ...(searchTerm && { name: searchTerm }),
  });

  const layoutList = data?.data;

  const rulesMemo = useRoleMemo({ required, rules, disabled });

  return (
    <FormSelect
      {...{ name, label, placeholder, disabled, ...props }}
      {...(multiple && { mode: 'multiple' })}
      loading={isInitialLoading || isRefetching}
      {...(rules || (required && { rules: rulesMemo }))}
      onChange={onChange}
      onSearch={handleSearch}
      showSearch
    >
      {layoutList?.map((layout) => (
        <Select.Option key={layout.id} value={layout.id}>
          {layout.name}
        </Select.Option>
      ))}
    </FormSelect>
  );
};

export default LayoutList;
